import { register } from '!/repository'
import { createEvent } from 'effector'
import { featuresMaxAutoQualityModel } from '~/features/max-auto-quality'

export const init = createEvent()

register(
  featuresMaxAutoQualityModel.selectMaxAutoQualityAuto,
  'settings/video-audio/selectMaxAutoQualityAuto'
)
register(
  featuresMaxAutoQualityModel.selectMaxAutoQualityLow,
  'settings/video-audio/selectMaxAutoQualityLow'
)
register(
  featuresMaxAutoQualityModel.selectMaxAutoQualityMedium,
  'settings/video-audio/selectMaxAutoQualityMedium'
)
register(
  featuresMaxAutoQualityModel.selectMaxAutoQualityHigh,
  'settings/video-audio/selectMaxAutoQualityHigh'
)
register(
  featuresMaxAutoQualityModel.$isMaxAutoQualityAuto,
  '$settings/video-audio/isMaxAutoQualityAuto'
)
register(
  featuresMaxAutoQualityModel.$isMaxAutoQualityLow,
  '$settings/video-audio/isMaxAutoQualityLow'
)
register(
  featuresMaxAutoQualityModel.$isMaxAutoQualityMedium,
  '$settings/video-audio/isMaxAutoQualityMedium'
)
register(
  featuresMaxAutoQualityModel.$isMaxAutoQualityHigh,
  '$settings/video-audio/isMaxAutoQualityHigh'
)
